var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.395,
    height: 66,
    viewBox: "0 0 63.395 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-1716.605 -44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bcd7e93b469c95a276df1884e90d3ade",
    d: "M17.333,17.667A7.333,7.333,0,1,0,10,10.333,7.333,7.333,0,0,0,17.333,17.667Zm0,36.667a7.333,7.333,0,1,0,7.333,7.333A7.333,7.333,0,0,0,17.333,54.333Zm0-25.667A7.333,7.333,0,1,0,24.667,36,7.333,7.333,0,0,0,17.333,28.667Z",
    transform: "translate(1755.333 41)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bcd7e93b469c95a276df1884e90d3ade-2",
    "data-name": "bcd7e93b469c95a276df1884e90d3ade",
    d: "M17.333,17.667A7.333,7.333,0,1,0,10,10.333,7.333,7.333,0,0,0,17.333,17.667Zm0,36.667a7.333,7.333,0,1,0,7.333,7.333A7.333,7.333,0,0,0,17.333,54.333Zm0-25.667A7.333,7.333,0,1,0,24.667,36,7.333,7.333,0,0,0,17.333,28.667Z",
    transform: "translate(1730.969 41)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bcd7e93b469c95a276df1884e90d3ade-3",
    "data-name": "bcd7e93b469c95a276df1884e90d3ade",
    d: "M17.333,17.667A7.333,7.333,0,1,0,10,10.333,7.333,7.333,0,0,0,17.333,17.667Zm0,36.667a7.333,7.333,0,1,0,7.333,7.333A7.333,7.333,0,0,0,17.333,54.333Zm0-25.667A7.333,7.333,0,1,0,24.667,36,7.333,7.333,0,0,0,17.333,28.667Z",
    transform: "translate(1706.605 41)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu-icon.f3caf15ceccda1c855e24b3bb46f5af5.svg";
export { ForwardRef as ReactComponent };